import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';
import img from '../../../assests/logo.jpg'

// DOC
// https://pdfmake.github.io/docs/0.1/document-definition-object/qr/

export class Impressao {

  constructor(dadosParaImpressao) {
    this.dadosParaImpressao = dadosParaImpressao;
  }

  async PreparaDocumento() {
    const corpoDocumento = this.CriaCorpoDocumento();
    const documento = this.GerarDocumento(corpoDocumento);
    return documento;
  }

  CriaCorpoDocumento() {
    const headerWagon = [
      { text: '#', bold: true, fontSize: 20, margin: [0, 4, 0, 0] },
      { text: 'Forno', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Combinação', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
    ];

    const headerMold = [
      { text: 'Ordem Produção', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Peça', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Produto', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Cod. Veículo', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Veículo', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Bomba A', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Bomba B', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Bomba C', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Lote Molde', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Código Molde', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
      { text: 'Descrição Molde', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
    ];

    const bodyWagon = [[
      { text: this.dadosParaImpressao.wagon.vagao_Serial, fontSize: 8 },
      { text: this.dadosParaImpressao.typesPiecesCombinations.forno, fontSize: 8 },
      { text: this.dadosParaImpressao.typesPiecesCombinations.comb_Nome, fontSize: 8 },
    ]];

    const bodyMold = this.dadosParaImpressao.moldsWagon.map(({ mold, piece }) => {
      const getMold = this.dadosParaImpressao.wagon?.isagA_Vagoes_Fornos_Pecas?.some(w => w.ordem_Serial === piece.ordem_Serial && !w.ativo || mold.molde_Status === "INDISPONIVEL")

      if (getMold)
        return [
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
          { text: "", fontSize: 8 },
        ];

      return [
        { text: piece.ordem_Serial, fontSize: 8 },
        { text: piece.ordem_Part_Short, fontSize: 8 },
        { text: piece.subProduto_Desc, fontSize: 8 },
        { text: piece.ordem_VehCod, fontSize: 8 },
        { text: piece.ordem_VehDesc, fontSize: 8 },
        { text: piece.bomba_A, fontSize: 8 },
        { text: piece.bomba_B, fontSize: 8 },
        { text: piece.bomba_C, fontSize: 8 },
        { text: mold.molde_Lote, fontSize: 8 },
        { text: mold.molde_Codigo, fontSize: 8 },
        { text: mold.molde_Descricao, fontSize: 8 },
      ]
    });

    const lineHeadercolSpanWagon = [
      {
        text:
          '__________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
        alignment: 'center',
        fontSize: 5,
        colSpan: 3,
      },
      {},
      {},
    ];

    const lineHeadercolSpanMold = [
      {
        text:
          '__________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
        alignment: 'center',
        fontSize: 5,
        colSpan: 11,
      },
      {},
      {},
    ];

    const xmlSerializer = new XMLSerializer();
    const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
    const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    JsBarcode(svgNode, `${this.dadosParaImpressao.wagon.vagao_Serial}`, {
      xmlDocument: document,
      width: 3,
      height: 50,
      // displayValue: false
    });

    const svgText = xmlSerializer.serializeToString(svgNode);

    let contentWagon = [headerWagon, lineHeadercolSpanWagon];
    let contentMold = [headerMold, lineHeadercolSpanMold];

    contentWagon = [...contentWagon, ...bodyWagon];
    contentMold = [...contentMold, ...bodyMold];

    return { contentWagon, contentMold, svgText };
  }

  GetBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  async GerarDocumento({ contentWagon, contentMold, svgText }) {
    const documento = {
      pageSize: 'A4',
      pageMargins: [20, 53, 20, 48],
      header: function () {
        return {
          margin: [14, 12, 14, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                [      
                  {
                    text: 'RELATÓRIO DE PEÇAS',
                    style: 'reportName',
                    margin: [0, 10, 0, 0],
                    fontSize: 20,                    
                    alignment: 'center',
                  }                
                ],
              ],
            ],
          },
        };
      },

      content: [
        { text: 'Vagão', style: 'header' },
        {
          layout: 'noBorders',
          headerRows: 1,
          widths: ['*'],
          table: {
            body: contentWagon
          },
        },
        { text: 'Molde', style: 'header' },
        {
          layout: 'noBorders',
          headerRows: 1,
          widths: ['*'],
          table: {
            body: contentMold
          },
        },
        // {
        //   svg: svgText,
        //   style: 'image',
        // },
        {
          qr: this.dadosParaImpressao.wagon.vagao_Serial,
          style: 'image',

        },
      ],

      images: {
        snow: await this.GetBase64ImageFromURL(img),
      },

      footer(currentPage, pageCount) {
        return {
          layout: 'noBorders',
          margin: [14, 0, 14, 22],
          table: {
            widths: ['auto'],
            body: [
              [
                {
                  text:
                    '_________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________',
                  alignment: 'center',
                  fontSize: 5,
                },
              ],
              [
                [
                  {
                    text: `Página ${currentPage.toString()} de ${pageCount}`,
                    fontSize: 7,
                    alignment: 'right',
                    /* horizontal, vertical */
                    margin: [3, 0],
                  },
                  {
                    text: '© AGP Brasil',
                    fontSize: 7,
                    alignment: 'center',
                  },
                ],
              ],
            ],
          },
        };
      },
      styles: {
        reportName: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          margin: [0, 4, 0, 0]
        },
        header: {
          bold: true,
          fontSize: 8,
          margin: [0, 12, 0, 0],
        },
        image: {
          margin: [0, 30, 0, 0],
          // alignment: 'center'
        }
      },
    };

    return documento;
  }
}
